module.exports = __webpack_public_path__ + "assets/img/j-i5.33e91123.png";